const sendStats = (eventData) => {
  if (window.Spatz) {
    const data = {
      Services: {
        md: { ...eventData },
      },
    };
    window.Spatz.send(
      {
        type: 'md',
        src: 'mos.ru',
        data,
      },
      {
        yandex: true,
        mosStats: true,
      }
    );
  }
};

export const TRACK_SIGN_UP_MAIN_PAGE_CLICK = () => {
  sendStats({
    Главная: {
      'Клик на кнопку': {
        Записаться: 'click',
      },
    },
  });
};

export const TRACK_SERVICE_SELECT = () => {
  sendStats({
    Главная: {
      'Клик на Услуги': {
        'Выбрать из справочника': 'click',
      },
    },
  });
};

export const TRACK_SERVICE_SEARCH_OR_SELECT = (isSelect, serviceName) => {
  sendStats({
    'Выбрать услугу из справочника': {
      'Поиск услуги': {
        [serviceName]: {
          'отправлен запрос': isSelect ? 'Галочка' : 'Окно поиска',
        },
      },
    },
  });
};

export const TRACK_OFFICE_SEARCH = (isArea, isSelect) => {
  sendStats({
    Главная: {
      'Поиск центра': {
        [isArea ? 'Район' : 'Ближайшее метро']: {
          'активировано поле': isSelect ? 'Галочка' : 'Окно поиска',
        },
      },
    },
  });
};

export const TRACK_FAST_ACCESS_LINKS_CLICK = (linkName) => {
  sendStats({
    Главная: {
      'Клик на быстрые ссылки': {
        [linkName]: 'click',
      },
    },
  });
};

export const TRACK_OFFICE_INFO_BUTTON_CLICK = (buttonType) => {
  const buttonTypes = {
    goBack: 'Назад',
    header: 'Заголовок',
    services: 'Услуги центра',
  };

  sendStats({
    'Информация о центре на карте': {
      'Клик на': {
        [buttonTypes[buttonType]]: 'click',
      },
    },
  });
};

export const TRACK_POPUP_SIGN_UP_CLICK = () => {
  sendStats({
    'Информация о центре на карте': {
      'Клик на ': {
        'Записаться на прием': 'click',
      },
    },
  });
};

export const TRACK_OFFICE_PAGE_SERVICE_SEARCH = (serviceName) => {
  sendStats({
    'Страница МФЦ': {
      'Клик на ': {
        'Окно поиска': {
          'отправлен запрос': serviceName,
        },
      },
    },
  });
};

export const TRACK_OFFICE_PAGE_SERVICE_SEARCH_VIA_CATALOG = (
  categoryName,
  serviceName
) => {
  sendStats({
    'Страница МФЦ': {
      'Клик на ': {
        [`Каталог: ${categoryName}`]: {
          click: serviceName,
        },
      },
    },
  });
};

export const TRACK_SIGN_UP_OFFICE_PAGE_CLICK = () => {
  sendStats({
    'Страница МФЦ': {
      'Клик на ': {
        Записаться: 'click',
      },
    },
  });
};

export const TRACK_POPULAR_SERVICES_SELECT = (isPopular, serviceName) => {
  sendStats({
    'Запись на приём': {
      'Выбор услуги': {
        [`Список: ${isPopular ? 'Популярные услуги' : 'Поиск по услугам'}`]: {
          click: serviceName,
        },
      },
    },
  });
};
